<template>
    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <!-- 搜索区域-->
            <div style="margin-right: 20px">
                <span class="titlew">选择食堂</span>
                <el-select
                        size="mini"
                        style="width: 200px ; margin-right:10px;margin-left: 5px"
                        clearable class="input-width"
                        v-model="canteen"
                        filterable>
                    <el-option
                            v-for="item in canteenData"
                            :key="item.canteen"
                            :label="item.canteenName"
                            :value="item.canteen">
                    </el-option>
                </el-select>
                <span class="titlew" >选择时间</span>
                <el-date-picker
                        size="mini" style="width:200px"
                        v-model="startTime"
                        type="datetime"
                        :picker-options="dateLimit"
                        placeholder="开始时间"
                        value-format="yyyy-MM-dd-HH-mm-ss"
                        @blur="startChange"
                        clearable
                >
                </el-date-picker>
                <span class="titlew" >至</span>
                <el-date-picker size="mini" style="width: 200px; margin-right:15px; "
                                v-model="endTime"
                                type="datetime"
                                :picker-options="dateLimit"
                                clearable
                                placeholder="结束时间"
                                value-format="yyyy-MM-dd-HH-mm-ss"
                                @blur="endChange"
                >
                </el-date-picker>
                <!-- 搜索框 -->
                <el-input
                        size="mini"
                        style="width: 200px  "
                        placeholder="请输入搜索内容"
                        v-model="searchData"
                        clearable>
                </el-input>
                <!-- 搜索按钮 -->
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
            </div>

        </div>
        <!--  表格  -->
        <el-table
                id="eltable"
                ref="ftable"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                style="width: 100%"
                stripe
                border
                :header-cell-style="{background:'#eef1f6',color:'black',}"
                :header-row-style="{height:'50px'}"
                :highlight-current-row="true"
        >
            <el-table-column type="expand"  ref="tree">
                <!--   子表   -->
                <template slot-scope="scope" width="1">
                    <el-table
                            ref="table"
                            size="mini"
                            border
                            :data="scope.row.orderFoodEvaluateListDto"
                            :header-cell-style="{background:'#F0FFFF',color:'#000',}"
                    >
                        <el-table-column
                                type="index"
                                label="序号"
                                align="center"
                                width="50px"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="菜品名称"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
<!--                        <el-table-column-->
<!--                                prop="price"-->
<!--                                label="原价(元)"-->
<!--                                align="center"-->
<!--                                show-overflow-tooltip>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                                prop="num"-->
<!--                                label="售价(元)"-->
<!--                                align="center"-->
<!--                                show-overflow-tooltip>-->
<!--                        </el-table-column>-->
<!--                        <el-table-column-->
<!--                                prop="total"-->
<!--                                label="数量(份)"-->
<!--                                align="center"-->
<!--                                show-overflow-tooltip>-->
<!--                        </el-table-column>-->
                        <el-table-column
                                prop="satisfaction"
                                label="评分"
                                align="center"
                                show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                                label="总分"
                                align="center"
                                show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>5</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
                <!--   子表   -->
            </el-table-column>
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="state"-->
<!--                    label="订单编号"-->
<!--                    width="90px"-->
<!--                    show-oveflow-tooltip>-->
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.state==1">是</span>-->
<!--                    <span v-if="scope.row.state==0">否</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="code"
                    label="订单编号 "
                    width="220"
                    show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
                    prop="name"
                    label="用户名"
                    width="90"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="cateringName"
                    label="餐别"
                    width="80"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    prop="canteenName"
                    label="食堂名称"
                    width="100"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="就餐类型"
                    width="80"
                    show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span>{{scope.row.orderType==1?'堂食':'外带'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="evaluate"
                    label="文字评价"
                    show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
                    label="评价图片"
            >
                <template slot-scope="scope">
                    <el-image style="width: 60px; height: 60px;margin-left: 10px;margin-bottom: -10px;"
                              v-for="(item, index) in scope.row.files" :key="index" :src="filehead+item"
                              :preview-src-list="[filehead+item]"
                              slot="reference" :alt="filehead+item"
                    >
                    </el-image>
                    <div slot="error" class="image-slot" style="text-align: center; line-height: 60px;" v-if="scope.row.files.length==0">
                        无
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createtime"
                    label="评价日期"
                    width="150"
                    show-overflow-tooltip
            >
            </el-table-column>
<!--            <el-table-column-->
<!--                    width="250"-->
<!--                    label="操作">-->
<!--                <template slot-scope="scope" >-->
<!--                    <div>-->
<!--                        <el-button  type="text" size="mini" @click="editDish(scope.row)">编辑</el-button>-->
<!--                        <el-button  style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>-->
<!--                        <el-button  type="text" size="mini" @click="cprelease(scope.row)" :disabled="scope.row.state==1?true:false">确认发布</el-button>-->
<!--                    </div>-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>
        <!-- 分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10,20,30,40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {baseerp,smfile_root} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";

    export default {
        name: "dishEvaluation",
        components:{
        },
        data(){
            return{
                delDialog:false,
                startTime:'',
                endTime:'',
                searchData:'',
                currentPage:1,
                pageSize:10,
                deldetail:'',
                total:0,
                baseerp:'',
                filehead:'',
                canteen:'',
                canteenData:[

                ],
                tableData: [],
                tableHeight:0,//列表高度
                title:'',
                dateLimit: {
                    disabledDate: (time) => {
                        return time.getTime() > new Date().getTime()//禁用当前日期之后的日期
                    }
                },
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.getCanteenList()
            this.filehead=smfile_root
            this.getList()
            this.$nextTick(()=>{
                this.onResize();

            })
            // this.$refs.deliverlight.toggleRowExpansion(item,false)
            //公共样式
            this.baseerp=baseerp
        },
        methods:{
            //食堂下拉
            async getCanteenList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.getCanteenList(params);
                if (res.code == 1) {
                    this.canteenData=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            startChange(){
                if(this.endTime!=''){
                    if(this.endTime<this.startTime){
                        this.startTime=''
                        this.$message.error('请选择小于或等于结束时间的值')
                    }
                }
            },
            endChange(){
                if(!this.startTime && this.endTime){
                    this.endTime=''
                    this.$message.error('请先选择开始时间')
                }
                if(this.endTime&&this.endTime<this.startTime){
                    this.endTime=''
                    this.$message.error('请选择大于或等于开始时间的值')
                }
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

            },
            ...mapActions(["getCurrentMenuId"]),
            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36;
            },
            //关闭弹框
            close(){
                this.addDialog=false
            },
            //页面搜索
            Search(){
                if(!this.startTime&&!this.endTime){
                    this.getList()
                }else if(!this.endTime){
                    this.$message.error('请选择结束时间')
                }else if (!this.startTime){
                    this.$message.error('请选择开始时间')
                }else {
                    this.getList()
                }
                this.currentPage=1
            },
            //分页
            handleSizeChange(newsize) {
                this.pageSize = newsize;    //动态改变
                this.getList()
            },
            // 监听 页码值 改变的数据
            //监听页码值改变的数据
            handleCurrentChange(newPage) {
                this.currentPage = newPage;    //动态改变
                this.getList()
            },
            //删除菜谱(父)
            del(val){
                this.title='删除'
                this.editData=val
                this.deldetail='是否要删除'
                this.delDialog=true

            },
            //菜谱列表
            async getList(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    canteen:this.canteen
                    // starttime:this.startDate,
                    // endtime:this.endDate,
                    // foodType:this.foodType
                }
                let res = await API.getEvaluateList(params);
                if (res.code == 1) {
                    this.tableData=res.data
                    // this.tableData.forEach(item=>{
                    //     item.files.forEach(it=>{
                    //         it=smfile_root+it
                    //     })
                    // })
                    // console.log(this.tableData )
                    this.total=res.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            // 业务配置作废
            async remove() {
                // return
                // await this.getDetails()
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    date:this.editData.date
                }
                let res = await API.remove(params);
                if (res.code == 1) {
                    this.getList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: end;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/.el-table__expanded-cell{
        padding: 5px 0px;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }
    .titlew{
        padding: 0 10px;
        font-size: 14px;
    }
    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    /deep/.el-table__header{
        width: 100% !important;
    }
    /deep/.el-table__body{
        width: 100% !important;

    }
    .left{
        width: 17.857rem;
    }
</style>